import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import ApiService from "@/services/api.service"
import DocumentControlService from "@/services/info/documentcontrol.service"
import AccountService from "@/services/others/account.service"
import ManualService from "@/services/others/manual.service"
import store from "@/store"
import ErrorComponent from "./error.component.vue"

const Modal = {
  // Vue 3: install receives app instance instead of Vue constructor
  install(app, options) {
    app.config.globalProperties.$message = function (data) {
      if (data.status === 500) {
        // Vue 3: Use createApp instead of Vue.extend
        const container = document.createElement("div")
        document.body.appendChild(container)
        const errorApp = createApp({
          render() {
            return h(ErrorComponent, { visible: true, data })
          },
        })
        errorApp.mount(container)
      }
      if (data.status == 400) {
        const errors = Object.values(data.errors)
        const a = errors.map((el, item) => `${item + 1}.${el}`)
        this.$toast.error(a.join("\n"), {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          icon: true,
          rtl: false,
        })
      }
      if (data.status == 200 || data.status == 204) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: data.message,
            icon: "CheckSquareIcon",
            variant: "success",
          },
        })
      }
      if (data.status === 403) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${data.title} (status: ${data.status})`,
            icon: "CheckSquareIcon",
            variant: "danger",
          },
        })
      }
      // ponytail: fallback for bodies without a `status` field (423 Locked and friends)
      const handled = [200, 204, 400, 403, 500]
      if (!handled.includes(Number(data.status)) && data.message) {
        this.$notification(data.message, "danger")
      }
    }

    app.config.globalProperties.$notification = function (message, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: variant == "success" ? "CheckSquareIcon" : "AlertCircleIcon",
          variant,
        },
      })
    }

    app.config.globalProperties.$getstatuscolor = function (item, field) {
      field = field || "statusId" // Default to 'statusId' if no field is provided
      const colorMap = {
        1: "info",
        2: "success",
        3: "danger",
        4: "info",
        5: "danger",
        6: "info",
        7: "info",
        8: "warning",
        9: "success",
        10: "danger",
        11: "danger",
        12: "warning",
        13: "danger",
        14: "info",
        15: "success",
        16: "danger",
        17: "danger",
        18: "success",
        19: "success",
        20: "info",
        24: "danger",
        26: "success",
        30: "danger",
        34: "warning",
        46: "info",
        47: "info",
        48: "success",
        53: "warning",
        54: "primary",
        70: "primary",
        71: "success",
        72: "danger",
        73: "light-primary",
        74: "light-success",
        75: "light-info",
        80: "status-error",
        81: "status-checking-bank",
        82: "status-checking-client",
        83: "status-creating-client",
        84: "status-allow-transaction",
        85: "status-identified",
        86: "status-checking-bank-confirm",
        87: "status-preparing-abs",
        88: "status-sending-abs",
        89: "status-finish-purchase",
        90: "status-finish-sell",
        91: "status-checking-client-confirm",
        92: "status-delivered",
        93: "status-finish-order",
        94: "status-not-collected",
        95: "status-unsuccessful",
        96: "status-unsuccessful",
        98: "status-pending-verification",
        99: "status-unsuccessful",
        100: "secondary",
        101: "status-error",
        102: "status-accepted",
        103: "status-pending-expert",
        104: "status-sent-expert",
        105: "status-rejected",
        106: "status-for-payment",
        107: "status-rework",
        108: "status-printed",
      }

      return colorMap[item[field]] || "info"
    }

    app.config.globalProperties.$getiabsstatuscolor = function (item) {
      return item.iabsStatusId == 46
        ? "primary"
        : item.iabsStatusId == 47 ? "primary" : "info"
    }

    app.config.globalProperties.$checkDocumentControl = function (dbSettlementAccountId, ctSettlementAccountId, amount) {
      DocumentControlService.Check(dbSettlementAccountId, ctSettlementAccountId, amount).then((res) => {
        if (res.data.control == null) {
          return false
        } else {
          return true
        }
      }).catch((error) => {
        this.$message(error.response.data)
        return true
      })
    }

    app.config.globalProperties.$isRequireEsp = function () {
      AccountService.IsRequireEsp({ userName: JSON.parse(localStorage.getItem("user_info"))?.userName || "" }).then((res) => {
        return res.data.isRequireEsp
      }).catch((error) => {
        this.$message(error.response.data)
      })
    }

    app.config.globalProperties.$getVirtualSettlementAccount = function (filter) {
      filter.page = 1
      filter.pageSize = 10
      return ManualService.VirtualSettlementAccountSelectList(filter)
    }

    app.config.globalProperties.$getUserInfo = function () {
      return JSON.parse(localStorage.getItem("user_info")) || {}
    }

    app.config.globalProperties.$getTodayDate = function () {
      const today = new Date()
      const day = String(today.getDate()).padStart(2, "0")
      const month = String(today.getMonth() + 1).padStart(2, "0")
      const year = today.getFullYear()
      return `${day}.${month}.${year}`
    }

    app.config.globalProperties.$getBeginMonthDay = function () {
      const today = new Date()
      const month = String(today.getMonth() + 1).padStart(2, "0")
      const year = today.getFullYear()
      return `01.${month}.${year}`
    }

    app.config.globalProperties.$getSettlementAccount = function (filter) {
      filter.page = 1
      filter.pageSize = 10
      return ManualService.SettlementAccountSelectList(filter)
    }

    app.config.globalProperties.$getAllowTransaction = function (filter) {
      const keys = Object.keys(filter)
      let params = ""
      for (let i = 0; i < keys.length; i++) {
        params += `${keys[i]}=${filter[keys[i]]}&`
      }
      return ApiService.get(`/manual/AllowTransactionSelectList?${params}Page=${1}&PageSize=${10}`)
    }

    app.config.globalProperties.$logout = function () {
      // ponytail: fire-and-forget — tell the server, but don't await it,
      // or a failing API would trap the user inside the session. The local
      // session is dropped either way; the toast only reports that the
      // server-side one could not be closed.
      AccountService.Logout().catch((error) => {
        // ponytail: locales/*.json are regenerated from the translation
        // sheet on every build, so fall back to a key that is already
        // there if `logoutServerError` has not been added to it yet
        const fallback = this.$te("logoutServerError")
          ? this.$t("logoutServerError")
          : this.$t("AppError")
        this.$notification(error.response?.data?.message || fallback, "danger")
      })
      localStorage.clear()
      store.state.UnreadDocCount.cashrequirement = 0
      store.state.UnreadDocCount.cashrequirementbycurrency = 0
      store.state.UnreadDocCount.incomecashorder = 0
      store.state.UnreadDocCount.incomecashorderoutofbalance = 0
      store.state.UnreadDocCount.offbalancerequirement = 0
      store.state.UnreadDocCount.outcomecashorderoutofbalance = 0
      store.state.UnreadDocCount.outgoingcashorder = 0
      store.state.UnreadDocCount.reinforcement = 0
      store.state.UnreadDocCount.sendtreasuremoney = 0
      this.$router.push({ name: "auth-login" })
    }

    app.config.globalProperties.$tableHeight = function () {
      const height = window.innerHeight
      const coef = height / window.outerHeight
      if (coef > 3) {
        return `${height * 0.9}px`
      } else if (coef > 1.5 && coef < 2) {
        return `${height * 0.8}px`
      } else if (coef > 1 && coef < 1.5) {
        return `${height * 0.7}px`
      } else if (coef < 1) {
        return `${height * 0.6}px`
      }
    }
  },
}
export default Modal
